import React, {CSSProperties, useEffect, useMemo, useRef} from 'react'
import Reflux from 'reflux-react-16'

import _ from 'lodash'
import moment from 'moment'

import useVehicleStore from '../../src/stores/VehicleStore.js'
import OrderStore from '../stores/OrderStore.js'
import OrderActions from '../actions/OrderActions.js'
import geolocation from '../utils/geolocation.js'

import {SelectRoutePopup} from '../components/index.js'
import {Button, Card, Colors, H3, Icon, IconButton, P, Popup, Row, Spinner, Panel, Popover, ListItem, H6, Badge, H5} from '../../src/components/UI/index.js'
import ColliNotReadyPopup from '../components/UI/ColliNotReadyPopup.js'
import {Reseller} from '../../server/functions/resellers/resellers.types.js'
import {User} from '../../server/functions/users/users.types.js'
import {FrontEndRoute} from '../../server/functions/route/route.types.js'
import {BrandingObject} from '../../server/functions/login/login.types.js'
import {Shift} from '../../server/functions/shifts/shifts.types.js'
import {emit} from 'messenger/socketio/socketEmit.js'
import {Location} from 'types/types.js'
import {formatDistance, formatDuration} from '@utils/utils.js'
import stopBundles from '@utils/stopBundles.js'
import t from 'src/helpers/Languages.js'

interface RouteOverviewProps {
    reseller: Reseller
    user: User
    history: string[]
    branding: BrandingObject
    shift: Shift
    selectedRoute: string
    routes: {
        [routeId: string]: FrontEndRoute
    }
    route: FrontEndRoute
    location: Location
    date: string
    isScanning: boolean
    editRoute: boolean
    loading: boolean
}

function RouteOverview({reseller, history, branding, shift, selectedRoute, routes, route, date, isScanning, loading, location}: RouteOverviewProps) {
    const vehicles = useVehicleStore((state) => state.vehicles)
    const getVehicles = useVehicleStore((state) => state.getVehicles)
    const popupRef = useRef(null)
    const commentPopupRef = useRef(null)
    const colliNotReadyPopupRef = useRef(null)
    const selectRoutePopup = useRef(null)

    useEffect(() => {
        getVehicles()

        console.log(route)

        localStorage.lastView = '/koerier/route'
    }, [])

    const onClickSelectRoute = async () => {
        if (!selectRoutePopup.current) {
            return
        }
        const {newDate, newSelectedRoute} = await selectRoutePopup.current.open(date, routes, selectedRoute)

        if (newDate !== date) {
            OrderActions.setDate(newDate)
        } else if (newSelectedRoute !== selectedRoute) {
            OrderActions.selectRoute(newSelectedRoute)
        }
    }

    const onClickStart = async () => {
        try {
            const gpsRequired = _.some(route.orders, (order) => {
                return _.some(order.addresses, (address) => address.gpsRequired)
            })

            if (gpsRequired) {
                await geolocation.checkPermissions()
            }

            const orderColli = {}
            const colliNotReady = []

            route.colli.map((collo) => {
                if (isScanning) {
                    if (!collo.started && collo.ready) {
                        orderColli[collo.orderId] = orderColli[collo.orderId] || []
                        orderColli[collo.orderId].push(collo)
                    }

                    if (!collo.ready) {
                        colliNotReady.push(collo)
                    }
                } else {
                    if (!collo.started && !collo.expected) {
                        orderColli[collo.orderId] = orderColli[collo.orderId] || []
                        orderColli[collo.orderId].push(collo)
                    }
                }
            })

            const startRoute = async (noPopup = false) => {
                const startRouteAction = () => {
                    OrderActions.startRoute(route._id, orderColli, async (err, errors) => {
                        if (err) {
                            popupRef.current?.setError(err)
                        } else if (errors.length) {
                            popupRef.current?.setErrors(errors)
                        } else {
                            history.push('/koerier/adressen')
                            popupRef.current?.close()

                            const activityId = reseller.settings.shifts?.activities?.find((activity) => activity.trigger === 'route')?.id

                            if (shift && activityId) {
                                if (!location?.lat) {
                                    location = await geolocation.getCurrentPosition(reseller.settings.shifts.gpsRequired)
                                }

                                try {
                                    await emit('shifts.startActivity', {id: shift._id, activityId, location})
                                } catch (error) {
                                    console.error(error)
                                }
                            }
                        }
                    })
                }

                const routeNotOptimized = route.addresses.some((address) => typeof address.priority !== 'number')

                if (reseller.settings.routeNotOptimizedWarning === 'notallowed' && routeNotOptimized) {
                    popupRef.current?.setActionButtons([{
                        variant: 'solid',
                        color: branding?.color || Colors.brandColor,
                        label: t('optimizeAndStart'),
                        onClick: async () => {
                            try {
                                await emit('orders.planRoute', {routeId: route._id, optimize: true})
                                popupRef.current?.close()
                                startRouteAction()
                            } catch (err) {
                                popupRef.current?.setError(err.message || err.toString())
                            }
                        }
                    }])
                    if (!await popupRef.current?.open('Route starten', 'Route is niet geoptimaliseerd. Optimaliseer de route voordat je deze start.')) return
                    return
                } else if (reseller.settings.routeNotOptimizedWarning === 'warning' && routeNotOptimized) {
                    popupRef.current?.setWarning('Route is niet geoptimaliseerd. Wil je de route toch starten?')
                    if (!await popupRef.current?.open('Route starten')) return
                    startRouteAction()
                } else {
                    if (noPopup) {
                        startRouteAction()
                    } else {
                        if (!await popupRef.current?.open('Route starten', 'Weet je zeker dat je deze route wilt starten?')) return
                        startRouteAction()
                    }
                }
            }

            if (colliNotReady.length > 0) {
                colliNotReadyPopupRef.current?.open(colliNotReady, startRoute, () => {
                    // this.setState({loading: false})
                })
            } else {
                startRoute()
            }
        } catch (err) {
            await popupRef.current?.setError(err.message || err?.toString())
        }
    }

    const cardStyle: CSSProperties = {
        aspectRatio: '1 / 1',
        height: '100%',
        padding: 12,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        borderRadius: 12
    }

    const cardTitleStyle: React.CSSProperties = {
        alignItems: 'center',
        justifyContent: 'center',
        gap: 12
    }

    const mainNumberStyle: CSSProperties = {
        fontSize: 'calc(10px + 3vw)',
        fontWeight: 400,
        textAlign: 'center',
        margin: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flex: 1
    }

    const [vehicle, vehicleType] = useMemo(() => {
        if (!Array.isArray(vehicles) || !Array.isArray(reseller.settings.vehicleTypes)) {
            return [undefined, undefined]
        }

        const vehicleType = reseller.settings.vehicleTypes.find((vehicleType) => vehicleType._id === route.vehicleTypeId)
        const vehicle = vehicles.find((vehicle) => vehicle._id === route.vehicleId)

        return [vehicle, vehicleType]
    }, [vehicles, reseller.settings.vehicleTypes, route.vehicleTypeId, route.vehicleId])

    const customBranding = branding && branding.color
    const currentActivity = shift && reseller.settings.shifts?.activities?.find((activity) => activity.id === shift.activityId)
    const shiftStartRequired = (reseller.settings.shifts?.shiftRequired && (!shift || !shift?.started || shift?.paused || shift?.completed)) || currentActivity?.lockAppActivity

    let actualDurationSec = 0
    let delay = 0

    if (route?.startTime && route?.endTime) {
        const start = moment(route.startTime).startOf('minute')
        let end = moment(route.endTime).startOf('minute')

        if (start.isValid() && end.isValid()) {
            actualDurationSec = end.diff(start, 'seconds')
            delay = actualDurationSec - (route?.plannedDuration || 0)
        }
    }

    return (
        <>
            <div style={{width: '100%', flex: 1, height: 'calc(100% - 50px)', display: 'flex', flexDirection: 'column', overflowY: 'auto'}}>

                {!isScanning &&
                    <Panel style={{display: 'flex', gap: 6, width: '100%', padding: '12px 6px 12px 6px', borderTop: 'none', borderRight: 'none', borderLeft: 'none'}}>
                        <div style={{width: 36}}>
                            <IconButton
                                onClick={onClickSelectRoute}
                                badge={Object.values(routes).filter((r) => !r.completed && r._id !== route._id).length}
                            >
                                <i className='mdi mdi-map-marker-path' />
                            </IconButton>
                        </div>

                        <div style={{flex: 1}}>
                            {route?.loadingRequiredBeforeStart && !route.loaded && !route.started &&
                                <Button
                                    variant='solid'
                                    color={branding?.color || Colors.brandColor}
                                    style={{flex: 1}}
                                    icon='mdi mdi-barcode-scan'
                                    label='Route inladen'
                                    disabled={date !== moment().format('YYYY-MM-DD') || _.keys(routes).length === 0 || shiftStartRequired}
                                    onClick={async () => {
                                        OrderActions.startScanning()
                                        history.push('/koerier/adressen')

                                        const activityId = reseller.settings.shifts?.activities?.find((activity) => activity.trigger === 'loading')?.id

                                        if (shift && activityId) {
                                            if (!location?.lat) {
                                                location = await geolocation.getCurrentPosition(reseller.settings.shifts.gpsRequired)
                                            }

                                            try {
                                                await emit('shifts.startActivity', {id: shift._id, activityId, location})
                                            } catch (error) {
                                                console.error(error)
                                            }
                                        }
                                    }}
                                />
                            }

                            {(route?.loadingRequiredBeforeStart ? route.loaded : route.loaded ? !route.started : (route.hasReadyToStartColli || (route.hasUnstartedColli && !route.hasStartedColli))) &&
                                <Button
                                    variant='solid'
                                    color={branding?.color || Colors.brandColor}
                                    style={{flex: 1}}
                                    icon='mdi mdi-arrow-right-bold-circle'
                                    label='Route starten'
                                    disabled={date !== moment().format('YYYY-MM-DD') || !route.hasReadyToStartColli || shiftStartRequired}
                                    onClick={onClickStart}
                                />
                            }

                            {!route.completed && (route.loaded ? route.started : (!route.hasReadyToStartColli && route.hasStartedColli)) &&
                                <Button
                                    variant='solid'
                                    color={branding?.color || Colors.brandColor}
                                    style={{flex: 1}}
                                    icon='mdi mdi-flag-checkered'
                                    label='Route afronden'
                                    disabled={route.hasUnCompletedColli || shiftStartRequired}
                                    onClick={() => {
                                        popupRef.current.open('Route afronden', 'Weet je zeker dat je deze route wilt afronden?', () => {
                                            OrderActions.stopRoute(route._id, async (err, errors) => {
                                                if (err) {
                                                    popupRef.current.setError(err)
                                                } else if (errors.length) {
                                                    popupRef.current.setErrors(errors)
                                                } else {
                                                    popupRef.current.close()

                                                    const activityId = reseller.settings.shifts?.activities?.find((activity) => activity.trigger === 'other')?.id

                                                    if (shift && activityId) {
                                                        if (!location?.lat) {
                                                            location = await geolocation.getCurrentPosition(reseller.settings.shifts.gpsRequired)
                                                        }

                                                        try {
                                                            await emit('shifts.startActivity', {id: shift._id, activityId, location})
                                                        } catch (error) {
                                                            console.error(error)
                                                        }
                                                    }
                                                }
                                            })
                                        })
                                    }}
                                />
                            }
                        </div>

                        <div style={{width: 36}}>
                            <Popover
                                placement='left'
                                popoverStyle={{width: 200}}
                                content={
                                    <ListItem
                                        icon='mdi mdi-barcode-scan'
                                        disabled={date !== moment().format('YYYY-MM-DD') || _.keys(routes).length === 0 || !route.hasUnstartedColli || shiftStartRequired}
                                        onClick={async () => {
                                            OrderActions.startScanning()
                                            history.push('/koerier/adressen')

                                            const activityId = reseller.settings.shifts?.activities?.find((activity) => activity.trigger === 'loading')?.id

                                            if (shift && activityId) {
                                                if (!location?.lat) {
                                                    location = await geolocation.getCurrentPosition(reseller.settings.shifts.gpsRequired)
                                                }

                                                try {
                                                    await emit('shifts.startActivity', {id: shift._id, activityId, location})
                                                } catch (error) {
                                                    console.error(error)
                                                }
                                            }
                                        }}
                                    >
                                        Route inladen
                                    </ListItem>
                                }
                            >
                                <IconButton>
                                    <i className='mdi mdi-dots-vertical' />
                                </IconButton>
                            </Popover>
                        </div>
                    </Panel>
                }

                {loading ?
                    <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', flex: 1}}>
                        <Spinner color={Colors.textDark} />
                    </div> :
                    _.keys(routes).length === 0 ?
                        <H6 style={{marginBottom: 12, marginTop: 15, textAlign: 'center'}}>Geen routes</H6> :
                        <div style={{width: 'calc(100% - 48px)', marginLeft: 'auto', marginRight: 'auto', display: 'flex', flexDirection: 'column', gap: 12}}>
                            <Row style={{padding: 12, alignItems: 'center', justifyContent: 'center', gap: 12, flexWrap: 'wrap'}}>
                                <H3 style={{margin: 0}}>{`${route.name}${route.plannedStartTime ? ` (${route.plannedStartTime})` : ''}`}</H3>
                                {route.completed ?
                                    <Badge variant='success'>Afgerond</Badge> :
                                    route.started ?
                                        <Badge textColor={Colors.textDark} variant='info'>Onderweg</Badge> :
                                        route.ready ?
                                            <Badge color={Colors.infoPale}>Gereed</Badge> :
                                            <Badge variant='grey'>Concept</Badge>
                                }
                            </Row>

                            <div style={{display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 12}}>
                                <Card style={cardStyle}>
                                    <Row style={cardTitleStyle}>
                                        <Icon
                                            icon='mdi mdi-home-outline'
                                            style={{fontSize: 24, margin: 0}}
                                        />
                                        <P style={{fontWeight: 700}}>Stops</P>
                                    </Row>

                                    <H3 style={mainNumberStyle}>{stopBundles.countStops(route.addresses || [])}</H3>
                                </Card>

                                <Card style={{...cardStyle, ...{
                                    justifyContent: 'space-between'
                                }}}
                                >
                                    <Row style={cardTitleStyle}>
                                        <Icon
                                            icon={`mdi mdi-${vehicleType?.icon || 'bicycle-cargo'}`}
                                            style={{fontSize: 24, margin: 0}}
                                        />
                                        <P style={{fontWeight: 700}}>Voertuig</P>
                                    </Row>

                                    <div style={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        height: '100%',
                                        flex: 1
                                    }}
                                    >
                                        <H3 style={{...mainNumberStyle, ...{
                                            display: '-webkit-box',
                                            width: '100%',
                                            wordBreak: 'break-word',
                                            overflow: 'hidden',
                                            flex: 'unset',
                                            WebkitLineClamp: 3,
                                            WebkitBoxOrient: 'vertical'
                                        }}}
                                        >{(vehicle?.name || vehicleType?.name || '-')}
                                        </H3>
                                    </div>

                                    {(vehicle?.comment || vehicleType?.comment) &&
                                        <IconButton
                                            icon='mdi mdi-message-alert'
                                            style={{color: customBranding || Colors.brandColor}}
                                            onClick={() => {
                                                commentPopupRef.current?.open('Opmerking', vehicle?.comment || vehicleType?.comment, () => commentPopupRef.current?.close())
                                            }}
                                        />
                                    }
                                </Card>

                                <Card style={cardStyle}>
                                    <Row style={cardTitleStyle}>
                                        <Icon
                                            icon='mdi mdi-map-marker-distance'
                                            style={{fontSize: 24, margin: 0}}
                                        />
                                        <P style={{fontWeight: 700}}>Afstand</P>
                                    </Row>

                                    <div style={{flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center'}}>
                                        <H3 style={{...mainNumberStyle, flex: 0}}>
                                            {route?.endTime && route?.completedDistance ?
                                                formatDistance(route.completedDistance) :
                                                route.plannedDistance ?
                                                    formatDistance(route.plannedDistance) :
                                                    '-- km'
                                            }
                                        </H3>

                                        <H5 style={{marginBottom: 24, marginTop: 6}}>{route?.endTime && route?.completedDistance ? formatDistance(route.completedDistance - route.plannedDistance, true) : ''}</H5>
                                    </div>

                                </Card>
                                <Card style={cardStyle}>
                                    <Row style={cardTitleStyle}>
                                        <Icon
                                            icon='mdi mdi-clock-outline'
                                            style={{fontSize: 24, margin: 0}}
                                        />
                                        <P style={{fontWeight: 700}}>ETA</P>
                                    </Row>

                                    <div style={{flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center'}}>
                                        <H3 style={{...mainNumberStyle, flex: 0}}>
                                            {(route.endTime || route.plannedEndTime) ? moment(route.endTime || route.plannedEndTime).format('HH:mm') : '--:--'}
                                        </H3>

                                        <H5 style={{marginBottom: 24, marginTop: 6}}>{route?.endTime ? formatDuration(delay, true) : ''}</H5>
                                    </div>
                                </Card>

                            </div>
                            {route.instructions &&
                                <div style={{padding: '12px 0'}}>
                                    <P style={{fontWeight: 700}}>Instructie</P>

                                    <Card style={{padding: 6, width: '100%'}}>
                                        <P style={{whiteSpace: 'pre-wrap'}}>{route.instructions}</P>
                                    </Card>
                                </div>
                            }
                        </div>
                }
            </div>

            <Popup ref={popupRef} />
            <Popup
                ref={commentPopupRef}
                confirmLabel='Sluiten'
                noCancelBtn
            />
            <SelectRoutePopup ref={selectRoutePopup} reseller={reseller} />
            <ColliNotReadyPopup ref={colliNotReadyPopupRef} />
        </>
    )
}

export default class RouteOverviewWrapper extends Reflux.Component {
    constructor(props) {
        super(props)

        // @ts-expect-error reflux-react-16 is not typed
        this.store = OrderStore
        // @ts-expect-error reflux-react-16 is not typed
        this.state = undefined
        // @ts-expect-error reflux-react-16 is not typed
        this.props = props
    }

    render() {
        return (
            // @ts-expect-error reflux-react-16 is not typed
            <RouteOverview {...this.props} {...this.state} />
        )
    }
}
